import React, { useContext, useEffect, useState } from 'react'
import { dataContext, localestr, toText, uid } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Panel from '../cmp/Panel'
import Menu from '../cmp/menu'
import icon from '../icons.svg'

let loading = false

function DocCalculationEdit({ data, actions }) {
  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabNew = actions.tabNew
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  //const getData=context.getData
  //const saveData=context.saveData
  const addTWnd = context.addTWnd
  const msg = context.msg
  const loaddata = context.loaddata
  const inputNumber = context.inputNumber
  const getSettings = context.getSettings

  //const Data=context.data['catTables']
  const selGoodType = context.data['selGoodType']
  const selUnitType = context.data['selUnitType']
  const selectionType = getSettings().selectionType || '0'
  const catGoods = context.getData('catGoods') || []
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id===(wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if((context.user || {}).rights?.urDocs3Edit){
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocs7Edit){
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocsREdit){
    if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if(urAdmin){
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if(posted){
    if(wndData.date && wndData.date > minDate){
      if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  //const [edit, setEdit] = useState(false)
  //const edit=(getGlData()||{}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  const [isActive2, setisActive] = useState(false)
  const cols = [
    { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    //{caption:'№',minWidth:'40',dataId:'id',sortable:true},
    { caption: localestr('Товар'), minWidth: '70', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('good', d) } },
    { caption: localestr('Тип'), minWidth: '75', maxWidth: '80', dataId: 'type', sortable: true },
    { caption: localestr('Од.'), minWidth: '30', maxWidth: '45',align:'center', dataId: 'unit', sortable: true },
    { caption: localestr('К-сть'), minWidth: '55', maxWidth: '60', dataId: 'sum_qtt', sortable: true, typeVal: 'number4', setFn: (d) => { setVal('sum_qtt', d) } },
    { caption: localestr('Нетто'), minWidth: '50', maxWidth: '60', dataId: 'sum_netto', sortable: true, typeVal: 'number0', setFn: (d) => { setVal('sum_netto', d) } },
    { caption: localestr('Сума'), minWidth: '60', maxWidth: '65', dataId: 'sum_amount', sortable: true },
    { caption: localestr('Примітка'), minWidth: '70', maxWidth: '110', dataId: 'note', sortable: true, typeVal: 'text', setFn: (d) => { setVal('note', d) } },
    { caption: localestr('Інший підрозділ'), minWidth: '70', maxWidth: '140', dataId: 'department', sortable: true, typeVal: 'catDepartments', setFn: (d) => { setVal('department', d) } },
  ]

  const filterData = [ //+
    { caption: localestr('Товар'), dataId: 'good', typeVal: 'catGoods' },
    { caption: localestr('Одиниця'), dataId: 'unit', typeVal: 'selUnitType' },
    { caption: localestr('К-сть'), dataId: 'sum_qtt', typeVal: 'number' },
    { caption: localestr('Сума'), dataId: 'sum_netto', typeVal: 'number' },
  ]

  const listFromData = (currentCol, setCurrCol) => {
    let list = []
    if (wndData.table) list = wndData.table.map((item) => {
      const newItem = {
        uid: uid(),
        id: item.id,
        good: { id: item.good_id, name: item.good, parent: { id: item.good_pid }, obj_type: 'catGoods' },
        type: selGoodType.find(x => x.value === item.type),
        unit: selUnitType.find(x => x.value === item.unit),
        sum_qtt: item.qtt,
        sum_netto: item.netto,
        note: item.note,
        ingr: item.ingr,
        department: item.department_id ? { id: item.department_id, name: item.department } : undefined,
      }
      if (item.edit) newItem.edit = true
      if (currentCol && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const setCol = (currentCol) => {
    if (!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    setWndData({ ...wndData, currentCol, oldCol })

    setGlData({ needFocus: 0 })
  }

  const setVal = (name, data) => {
    let currentCol = wndData.currentCol
    const old_qtt = parseFloat(currentCol.sum_qtt || 0)
    currentCol[name] = data
    if (name === 'good') {
      const sum_qtt = parseFloat(currentCol.sum_qtt || 1)
      let sum_netto = 0
      if (typeof currentCol.good.unit === 'string') currentCol.good.unit = selUnitType.find(el => el.value === currentCol.good.unit)
      currentCol.type = selGoodType.find(el => el.value === currentCol.good.type)
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 2 || parseInt(currentCol.good.unit.value) === 3) sum_netto = 1000 * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 10) sum_netto = sum_qtt
      if (typeof data.unit === 'object') currentCol.unit = data.unit
      else currentCol.unit = selUnitType.find(x => x.value === data.unit)
      currentCol.sum_qtt = sum_qtt.toFixed(4)
      currentCol.sum_netto = sum_netto.toFixed(0)
    } else if (name === 'sum_qtt') {
      const sum_qtt = parseFloat(data || 0)
      let sum_netto = parseInt(currentCol.sum_netto || 0) / (old_qtt || 1) * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 2 || parseInt(currentCol.good.unit.value) === 3) sum_netto = 1000 * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 10) sum_netto = sum_qtt
      currentCol.sum_netto = sum_netto.toFixed(0)
    }
    let newData = { ...wndData, currentCol }
    setWndData(newData)
    setEdit(true)
  }

  /*const cancelEdit=()=>{
      //const currentCol={...wndData.currentCol.cancel}
      //setWndData({...wndData,currentCol})
      
      setEdit(false)
      if(!wndData.currentCol.good && !wndData.currentCol.qtt){
          const list=wndData.list.filter(el=>el.uid!==wndData.currentCol.uid)
          setWndData({...wndData,list,currentCol:undefined})
      }
      setTimeout(()=>sortList(wndData.sorting.dataId,wndData.sorting.sort,wndData.list),25)
  }*/
  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (!newData.edit) newData.edit = true
    setWndData(newData, true)
  }

  const saveValue = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    const currCol = { ...wndData.currentCol, edit: true }
    const list = wndData.list
    if (!currCol) return
    if (!currCol.good) errmsg += localestr("Не заповнено товар")
    else {
      if (wndData.good && currCol.good.id === wndData.good.id) errmsg += localestr('Продукція не може включати сама себе')
      if (wndData.good && currCol.good.ingr && currCol.good.ingr.find(el => el.id === wndData.good.id)) errmsg += localestr('Цей товар не може бути використаний')
      let idx = list.findIndex(m => m.good && m.good.id === currCol.good.id && m.uid !== currCol.uid && !m.hide)
      if (idx !== -1) msg(localestr("Товар") + " " + currCol.good.name + " " + localestr("дублюється в рядку") + " " + (idx + 1), localestr('Попередження'), [{ caption: 'OK', action: () => { } }])
    }
    if (!currCol.sum_qtt) errmsg += localestr("Не заповнено кількість")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      currCol.sum_qtt = parseFloat(currCol.sum_qtt).toFixed(4)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      let netto = 0
      list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
      if (newData.netto !== netto) {
        newData.netto = netto
        if (!newData.edit) newData.edit = true
      }
      setWndData(newData, true)
      setEdit(false)
      setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
      else if (act) setTimeout(() => { act() }, 100)
    }
  }

  const newItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { newItem() }); return }
    //if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const copyItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { copyItem() }); return }
    //if (edit) return
    if (typeof wndData.currentCol === 'object') {
      setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    return
    /*if(posted) return
    if (edit) return
    if (!wndData.currentCol) return
    const currentCol={...wndData.currentCol}
    const oldCol={...wndData.currentCol}
    setWndData({...wndData,currentCol,oldCol})
    setEdit(true)*/
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const selectionClick = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionClick() }); return }
    let curVall = undefined
    if (wndData.currentCol) curVall = wndData.currentCol.good
    if (!curVall) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, undefined, undefined, 2)
    else if (curVall.parent) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, curVall, curVall.parent, 2)
    else addTWnd('Вибір', 'catGoods_list', selectionProc, curVall, undefined, 2)
  }

  const selectionProc = (e, qtt, sum) => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionProc(e, qtt, sum) }); return }
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if (wndData.good && e.id === wndData.good.id) { msg(localestr('Продукція не може включати сама себе'), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]); return }
    if (e.ingr && e.ingr.find(el => wndData.good && el.id === wndData.good.id)) { msg(localestr('Цей товар не може бути використаний'), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]); return }
    if (!qtt && parseInt(selectionType) > 0) { inputNumber(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) }); return }
    if (!qtt) qtt = 1
    let newData = { ...wndData }
    let list = newData.list
    let el = list.find(m => m.good?.id === e.id)
    if (!el) {
      let sum_netto = 0
      if (e.unit) if (parseInt(e.unit.value) === 2 || parseInt(e.unit.value) === 3) sum_netto = 1000 * qtt
      if (e.unit) if (parseInt(e.unit.value) === 10) sum_netto = qtt
      el = {
        uid: uid(),
        good: { ...e },
        unit: e.unit,
        type: selGoodType.find(el => el.value === e.type),
        sum_qtt: qtt.toFixed(4),
        sum_netto: sum_netto.toFixed(0),
        edit: true
      }
      list.push(el)
    } else if (el.hide) {
      let sum_netto = 0
      if (e.unit) if (parseInt(e.unit.value) === 2 || parseInt(e.unit.value) === 3) sum_netto = 1000 * qtt
      if (e.unit) if (parseInt(e.unit.value) === 10) sum_netto = qtt
      const sum_qtt = qtt
      el.sum_qtt = sum_qtt.toFixed(4)
      el.sum_netto = sum_netto.toFixed(0)
      el.hide = false
      el.edit = true
    } else {
      const sum_qtt = parseFloat(el.sum_qtt || 0) + qtt
      let sum_netto = parseInt(el.sum_netto || 0) / parseFloat(el.sum_qtt || 1) * sum_qtt
      el.sum_qtt = sum_qtt.toFixed(4)
      el.sum_netto = sum_netto.toFixed(0)
      el.edit = true
    }
    newData.currentCol = { ...el }
    newData.list = list
    let netto = 0
    list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
    if (newData.netto !== netto) { newData.netto = netto; newData.edit = true }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = () => {
    if (posted) return
    //if (edit) return
    if ((getGlData() || {}).edit) { saveValue(() => { removeItem() }); return }
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true, hide: true }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    let netto = 0
    list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
    newData.netto = netto
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const saveDoc = (d, close = true) => {
    if ((getGlData() || {}).edit) { saveValue(() => { saveDoc(d, close) }); return }
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      if (close) tabClose(false)
      else {
        let currentCol = wndData.currentCol
        let table = []
        if (d.data.table) table = d.data.table.map(el => ({ id: el.id, uid: el.uid, good_id: el.good.id, good: el.good.name, good_pid: el.good.pid, qtt: el.qtt, netto: el.netto, unit: el.unit, type: el.type, ingr: el.ingr, note: el.note, department_id: el.department?.id||'', department: el.department?.name }))

        let list = wndData.list.filter(el => !el.hide)
        list = list.map(el => ({ ...el, edit: false }))
        for (let i = 0; i < list.length; i++) {
          if (!list[i].id) {
            let idx = table.findIndex(el => el.uid === list[i].uid)
            if (idx === -1) idx = table.findIndex(el => el.good_id === list[i].good.id)
            if (idx !== -1) list[i].id = table[idx].id
          }
        }
        table = list.map(item => ({ id: item.id, good_id: item.good.id, good: item.good.name, good_pid: item.good.parent ? item.good.parent.id : null, qtt: item.sum_qtt, netto: item.sum_netto, unit: item.unit.value || item.unit, type: item.type, ingr: item.ingr, note: item.note, department_id: item.department?.id, department: item.department?.name }))
        let newData = { ...wndData, table, list, currentCol, id: d.data.id, edit: false }
        setWndData(newData, false)
      }
    } else {
      let data = {}
      if (wndData.edit) {
        if (wndData.id) data.id = wndData.id
        data.header = {
          author: wndData.author, date: wndData.date, good: wndData.good, qtt: wndData.qtt, netto: wndData.netto, cooking: wndData.cooking,
          conditions: (wndData.conditions || '').substring(0, 254), presentation: wndData.presentation || '', look: (wndData.look || '').substring(0, 254), colour: (wndData.colour || '').substring(0, 254),
          taste: (wndData.taste || '').substring(0, 254), consistence: (wndData.consistence || '').substring(0, 254), posted: wndData.posted
        }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }
      let table = wndData.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = { good: { id: el.good.id }, type:el.type, qtt: el.sum_qtt, netto: el.sum_netto, unit: el.unit.value || el.unit, ingr: el.ingr, note: el.note, department: { id: el.department?.id||'' } }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }
      
      if (posted){
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
                { caption: localestr('Відмінити'), action: () => { } },
                { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modCalculation&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }

      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modCalculation&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modCalculation&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modCalculation&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postCalculation&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postCalculation&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  const doc_print = (prn_type = 0) => {
    let item = { ...wndData, type: 'docCalculation', prn_type }
    item.table = item.list.map(it => {
      const idx = catGoods.findIndex((el) => el.id === it.good.id)
      const itm = {
        good_id: it.good.id,
        good: it.good.name,
        unit: typeof it.unit === 'object' ? it.unit.value : it.unit,
        qtt: it.sum_qtt,
        netto: it.sum_netto,
      }
      if (idx !== -1) itm.sum_prc = catGoods[idx].sum_in
      if (it.ingr) {
        let sum_prc = 0
        for (let j = 0; j < it.ingr.length; j++) {
          if (it.ingr[j].type > 1) continue
          const good_id = it.ingr[j].good
          const idx = catGoods.findIndex((it) => it.id === good_id)
          if (idx !== -1) sum_prc += parseFloat(catGoods[idx].sum_in || 0) * parseFloat(it.ingr[j].qtt || 0)
        }
        itm.sum_prc = sum_prc
      }
      return itm
    })
    if (prn_type) tabNew('docPrint', localestr('Технологічна карта'), item)
    else tabNew('docPrint', localestr('Калькуляція'), item)
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete') removeItem()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') filter()
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  useEffect(() => {
    if (context.data['catGoods'] === undefined) context.getData('catGoods')
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  let sum_am = 0
  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list.map(el => {
    const item = { ...el }
    const idx = catGoods.findIndex((it) => item.good && it.id === item.good.id)
    if (idx !== -1) item.sum_amount = (parseFloat(catGoods[idx].sum_in || 0) * parseFloat(item.sum_qtt || 0)).toFixed(2)
    if (item.ingr) {
      let sum_prc = 0
      for (let j = 0; j < item.ingr.length; j++) {
        if (item.ingr[j].type > 1) continue
        const good_id = item.ingr[j].good
        const idx = catGoods.findIndex((it) => it.id === good_id)
        if (idx !== -1) sum_prc += parseFloat(catGoods[idx].sum_in || 0) * parseFloat(item.ingr[j].qtt || 0)
      }
      item.sum_amount = (sum_prc * parseFloat(item.sum_qtt || 0)).toFixed(2)
    }
    sum_am += parseFloat(item.sum_amount || 0)
    return item
  })
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /> : ''  //+

  const menuDataP = [
    { name: localestr('Калькуляційна картка'), icon: '#b503', action: () => doc_print() },
    { name: localestr('Технологічна карта'), icon: '#b503', action: () => doc_print(1) },
  ]

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 20px)' }}>
        <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Калькуляція') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='80' width2='2' disabled={true} />
            <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '10px' }}></div>
            <EditCtrl Capt={localestr('від')} title={localestr('Дата починаючи з якої діє калькуляція')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='45' />
          </div>
        </div>

        <EditCtrl Capt={localestr('Страва / Напівфабрикат')} title={localestr('Страва, яку треба приготувати')} disabled={posted} Value={wndData.good} typeVal={'catGoods'} setVal={(d) => { setValue('good', d) }} width1='150' width2='10' />

        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('На кількість')} title={localestr('Скільки виробиться страви з набору інгредієнтів')} disabled={posted} Value={wndData.qtt} typeVal={'number3'} setVal={(d) => { setValue('qtt', d) }} width1='90' width2='50' />
          <div style={{ width: '70px', display: 'inline-block', flexGrow: 1, maxWidth: '140px', lineHeight: '24px' }}>{toText(wndData.good && wndData.good.unit ? selUnitType.find(x => x.value === wndData.good.unit.value) : '')}</div>
          <EditCtrl Capt={localestr('вихід  нетто')} title={localestr('Вага нетто готової страви, грам')} disabled={posted} Value={wndData.netto} typeVal={'text'} setVal={(d) => { setValue('netto', d) }} width1='86' width2='60' />
          <div style={{ width: '35px', display: 'inline-block', flexGrow: 1, maxWidth: '70px', lineHeight: '24px' }}>{localestr('гр')}</div>
          <div style={{ width: '70px', display: 'inline-block', flexGrow: 1, maxWidth: '140px', lineHeight: '24px' }}></div>
        </div>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
            onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
          ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}
            onClick={() => filter()}
            onKeyUp={(e) => { if (e.key === 'Enter') filter() }}><img src={icon + '#filtBut'} alt={localestr('Фільтр')} /></div>
          <div tabIndex='0' className='toolBarSeparator'></div>

          <div tabIndex='0' onClick={() => { selectionClick() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
            {localestr('Підбір')}
          </div>
          <div style={{ flexGrow: '10' }}></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} tblPos={tblPos} needFocus={needFocus} />
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Загальна вартість набору')}</div>
          <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{sum_am.toFixed(2)}</div>
        </div>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Загальна вартість одиниці виробу')}</div>
          <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{(sum_am / parseFloat(wndData.qtt || 1)).toFixed(2)}</div>
        </div>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Продажна ціна блюда')}</div>
          <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{(wndData.good || {}).sum_out || ''}</div>
        </div>
        <Panel caption={'Додатково'} width={792} open={wndData.p_head === undefined ? false : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
          <EditCtrl Capt={localestr('Технологія приготування страви')} title={localestr('Довгий і детальний опис як готувати страву')} disabled={posted} Value={wndData.cooking} typeVal={'longtext'} setVal={(d) => { setValue('cooking', d) }} width1='84' width2='792' />
          <EditCtrl Capt={localestr('Термін придатності та умови зберігання')} title={localestr('При якій температурі зберігати та протягом якого часу треба продати')} disabled={posted} Value={wndData.conditions} typeVal={'text'} setVal={(d) => { setValue('conditions', d) }} width1='300' width2='492' />
          <EditCtrl Capt={localestr('Спосіб реалізації (подання)')} title={localestr('Який потрібен посуд, як викласти страву та подати її гостю')} disabled={posted} Value={wndData.presentation} typeVal={'longtext'} setVal={(d) => { setValue('presentation', d) }} width1='84' width2='792' />
          <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px', fontWeight: '600' }}>{localestr('Характеристика готової страви')}</div>
          <EditCtrl Capt={localestr('Зовнішній вигляд')} disabled={posted} Value={wndData.look} typeVal={'text'} setVal={(d) => { setValue('look', d) }} width1='130' width2='662' />
          <EditCtrl Capt={localestr('Колір')} disabled={posted} Value={wndData.colour} typeVal={'text'} setVal={(d) => { setValue('colour', d) }} width1='100' width2='692' />
          <EditCtrl Capt={localestr('Смак і запах')} disabled={posted} Value={wndData.taste} typeVal={'text'} setVal={(d) => { setValue('taste', d) }} width1='100' width2='692' />
          <EditCtrl Capt={localestr('Консистенція')} disabled={posted} Value={wndData.consistence} typeVal={'text'} setVal={(d) => { setValue('consistence', d) }} width1='100' width2='692' />
        </Panel>
        <div className='no-print'>
          <div style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
            <div style={{ width: '100px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc(null, false)}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
            <div style={{ width: '70px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuDataP} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
          </div>
          {showFilter}
        </div>
      </div>
    )
  }

  //сумарна ширина 792px це розраховано на екран 1024px
  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)' }}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Калькуляція') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='114' width2='42' disabled={true} />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} title={localestr('Дата починаючи з якої діє калькуляція')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='168' />
        <div style={{ width: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Страва / Напівфабрикат')} title={localestr('Страва, яку треба приготувати')} disabled={posted} Value={wndData.good} typeVal={'catGoods'} setVal={(d) => { setValue('good', d) }} width1='184' width2='244' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('На кількість')} title={localestr('Скільки виробиться страви з набору інгредієнтів')} disabled={posted} Value={wndData.qtt} typeVal={'number3'} setVal={(d) => { setValue('qtt', d) }} width1='90' width2='60' />
        <div style={{ width: '70px', display: 'inline-block', flexGrow: 1, maxWidth: '140px', lineHeight: '24px' }}>{toText(wndData.good && wndData.good.unit ? selUnitType.find(x => x.value === wndData.good.unit.value) : '')}</div>
        <EditCtrl Capt={localestr('вихід  нетто')} title={localestr('Вага нетто готової страви, грам')} disabled={posted} Value={wndData.netto} typeVal={'text'} setVal={(d) => { setValue('netto', d) }} width1='86' width2='80' />
        <div style={{ width: '35px', display: 'inline-block', flexGrow: 1, maxWidth: '70px', lineHeight: '24px' }}>{localestr('грам')}</div>
        <div style={{ width: '70px', display: 'inline-block', flexGrow: 1, maxWidth: '140px', lineHeight: '24px' }}></div>
      </div>
      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}
          onClick={() => filter()}
          onKeyUp={(e) => { if (e.key === 'Enter') filter() }}><img src={icon + '#filtBut'} alt={localestr('Фільтр')} /></div>
        <div tabIndex='0' className='toolBarSeparator'></div>

        <div tabIndex='0' onClick={() => { selectionClick() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
          <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
          {localestr('Підбір')}
        </div>
        <div style={{ flexGrow: '10' }}></div>
      </div>
      <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} tblPos={tblPos} needFocus={needFocus} />
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Загальна вартість набору')}</div>
        <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{sum_am.toFixed(2)}</div>
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Загальна вартість одиниці виробу')}</div>
        <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{(sum_am / parseFloat(wndData.qtt || 1)).toFixed(2)}</div>
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Продажна ціна блюда')}</div>
        <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{(wndData.good || {}).sum_out || ''}</div>
      </div>
      <Panel caption={'Додатково'} width={792} open={wndData.p_head === undefined ? false : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
        <EditCtrl Capt={localestr('Технологія приготування страви')} title={localestr('Довгий і детальний опис як готувати страву')} disabled={posted} Value={wndData.cooking} typeVal={'longtext'} setVal={(d) => { setValue('cooking', d) }} width1='84' width2='792' />
        <EditCtrl Capt={localestr('Термін придатності та умови зберігання')} title={localestr('При якій температурі зберігати та протягом якого часу треба продати')} disabled={posted} Value={wndData.conditions} typeVal={'text'} setVal={(d) => { setValue('conditions', d) }} width1='300' width2='492' />
        <EditCtrl Capt={localestr('Спосіб реалізації (подання)')} title={localestr('Який потрібен посуд, як викласти страву та подати її гостю')} disabled={posted} Value={wndData.presentation} typeVal={'longtext'} setVal={(d) => { setValue('presentation', d) }} width1='84' width2='792' />
        <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px', fontWeight: '600' }}>{localestr('Характеристика готової страви')}</div>
        <EditCtrl Capt={localestr('Зовнішній вигляд')} disabled={posted} Value={wndData.look} typeVal={'text'} setVal={(d) => { setValue('look', d) }} width1='130' width2='662' />
        <EditCtrl Capt={localestr('Колір')} disabled={posted} Value={wndData.colour} typeVal={'text'} setVal={(d) => { setValue('colour', d) }} width1='100' width2='692' />
        <EditCtrl Capt={localestr('Смак і запах')} disabled={posted} Value={wndData.taste} typeVal={'text'} setVal={(d) => { setValue('taste', d) }} width1='100' width2='692' />
        <EditCtrl Capt={localestr('Консистенція')} disabled={posted} Value={wndData.consistence} typeVal={'text'} setVal={(d) => { setValue('consistence', d) }} width1='100' width2='692' />
      </Panel>
      <div className='no-print'>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '100px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc(null, false)}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
          <div style={{ width: '70px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuDataP} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
        </div>
        {showFilter}
      </div>
    </div>
  )

}

export default DocCalculationEdit